/**
 * <zf-marquee> — pause / resume button for the announcement marquee.
 * The animation itself is pure CSS; this only toggles the `is-paused` class.
 */
if (!customElements.get('zf-marquee')) {
  class ZfMarquee extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.zf-marquee__pause');
      if (!this.button) return;

      this.onClick = () => {
        const paused = this.classList.toggle('is-paused');
        this.button.setAttribute('aria-pressed', String(paused));
        this.button.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
      };
      this.button.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
    }
  }

  customElements.define('zf-marquee', ZfMarquee);
}
